// Веб-вклад модуля `calendar` — учебный календарь.
//
// Живёт под `/courses/calendar`, а не под `/calendar`: это раздел Обучения, а
// не самостоятельная сущность. Оба адреса объявлены роутами модуля — `/calendar`
// остаётся легаси-входом.
//
// Плитка воркспейса переключает вид сцены на календарь (поведение — смена URL,
// клиентский слой), генерации у неё нет.

import { IconCalendar } from "@tabler/icons-react";
import { SECTION_ICONS } from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const calendarWebManifest = {
	id: "calendar",
	icon: SECTION_ICONS.studyCalendar,
	labelKey: "nav.calendar",
	routes: ["/courses/calendar", "/calendar"],

	// Баннер объясняет МЕХАНИКУ: расписание не заполняют, его считает
	// планировщик — по одному дневному лимиту минут на ВСЕ активные курсы.
	// Ключи в словаре `study-plan`: там же живут остальные тексты экрана.
	intro: {
		titleKey: "study-plan:intro.title",
		bodyKey: "study-plan:intro.body",
		bulletKeys: [
			"study-plan:intro.bullets.0",
			"study-plan:intro.bullets.1",
			"study-plan:intro.bullets.2",
		],
	},

	nav: [
		{
			key: "calendar",
			to: "/courses/calendar",
			icon: SECTION_ICONS.studyCalendar,
			labelKey: "nav.calendar",
			order: 50,
		},
	],

	workspaceTools: [{ key: "calendar", channel: "plan", icon: IconCalendar, steps: { 1: 80 } }],
} satisfies WebModuleManifest;
